import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');
  const [plan, setPlan] = useState(null);
  const reference = searchParams.get('reference') || searchParams.get('trxref');

  useEffect(() => {
    if (!reference) { setStatus('failed'); return; }
    api.get(`/subscription/verify/${reference}`)
      .then(r => {
        if (r.data.status === 'success') {
          setStatus('success');
          setPlan(r.data.plan_id);
        } else {
          setStatus('failed');
        }
      })
      .catch(() => setStatus('failed'));
  }, [reference]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4" data-testid="payment-result-page">
      <div className="bg-white border border-slate-200 rounded-2xl p-10 max-w-md w-full text-center">
        {status === 'verifying' && (
          <>
            <Loader2 className="w-12 h-12 text-slate-400 animate-spin mx-auto mb-4" />
            <h2 className="text-xl font-bold text-slate-900 mb-2">Verifying Payment...</h2>
            <p className="text-sm text-slate-500">Please wait while we confirm your payment.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle2 className="w-16 h-16 text-emerald-500 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-slate-900 mb-2">Payment Successful!</h2>
            <p className="text-sm text-slate-500 mb-6">
              Your <span className="font-semibold text-slate-700">{plan === 'pro' ? 'Pro' : 'Standard'}</span> plan is now active.
            </p>
            <Button className="bg-slate-900 hover:bg-slate-800 text-white" onClick={() => navigate('/dashboard')} data-testid="go-dashboard-btn">
              Go to Dashboard
            </Button>
          </>
        )}
        {status === 'failed' && (
          <>
            <XCircle className="w-16 h-16 text-red-400 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-slate-900 mb-2">Payment Failed</h2>
            <p className="text-sm text-slate-500 mb-6">Something went wrong. Please try again.</p>
            <Button variant="outline" onClick={() => navigate('/dashboard')} data-testid="try-again-btn">
              Back to Dashboard
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
